// Workspace-name validation, frontend copy (SCD-1534).
//
// MIRROR of functions/src/lib/workspaceName.ts — the frontend can't import from
// functions/, so the rule is stated twice, the same way plan limits are (see
// const/constants.ts). The authority is firestore.rules, which enforces this on
// the direct client write; these checks exist to give a message instead of a
// silent permission-denied. Change all three together.
//
// Why the rule exists: the workspace name goes into the SUBJECT LINE of invite
// emails sent to addresses the inviter picks, so it is text leaving our domain.
// See the functions-side file for the incident this came from.

/** Longest accepted workspace name. p90 in production is 18 characters. */
export const WORKSPACE_NAME_MAX_LENGTH = 60

/** A scheme, a bare "www.", or any "domain.tld/" — the last catches shorteners. */
const URL_LIKE = /(https?:\/\/|www\.|[a-z0-9-]+\.[a-z]{2,}\/)/i

/**
 * Validate a workspace name typed by the user.
 *
 * Returns null when the name is acceptable, or a ready-to-show message when it
 * isn't.
 */
export function workspaceNameError(raw: string): string | null {
    const name = (raw ?? '').trim()

    if (!name) return "Workspace name can't be empty."
    if (name.length > WORKSPACE_NAME_MAX_LENGTH) {
        return `Workspace name can't be longer than ${WORKSPACE_NAME_MAX_LENGTH} characters.`
    }
    if (URL_LIKE.test(name)) return "Workspace name can't contain a link."

    return null
}
